<template>
	<ListOfPersonsMinWithFullName
		class='title-sm'
		:label='label'
		:count='count'
		:value='listOfPeopels'
		@select='selectAgentHandle'
	/>
</template>

<script>
import api from '__jsVueApi';
import ListOfPersonsMinWithFullName from '__jsVueSections/ListOfPersonsMinWithFullName/ListOfPersonsMinWithFullName.vue';
export default {
	name:       'PeopleTab',
	props: {
		market: {
			type:    [Boolean, Number],
			default: false
		},
		type: {
			type:    String,
			default: 'agent'
		},
		label: {
			type:    String,
			default: ''
		},
	},
	components: {
		ListOfPersonsMinWithFullName
	},
	data() {
		return {
			count:         0,
			pages:         0,
			listOfPeopels: []
		};
	},
	async mounted() {
		await this.loadPeople();
	},
	methods: {
		selectAgentHandle() {
			window.location.href = `/markets/${this.market}/?tab=Certified%20agents`;
		},
		async loadPeople() {
			let pageSize = 4;
			await axios.get(api.publicProfile.get(), {
				params: {
					market:    this.market,
					page_size: pageSize,
					page:      1,
					type:      this.type
				}
			}).then((response) => {
				this.listOfPeopels = response.data.results.filter(peopel => peopel.is_appointed) ?? [];
				this.count = this.listOfPeopels.length;
			});
		},
	}
};
</script>
